/* tslint:disable */
/* eslint-disable */
export enum RouterLinkStatus {
  RouterLinkOk = 'ROUTER_LINK_OK',
  RouterLinkAlreadyRequested = 'ROUTER_LINK_ALREADY_REQUESTED',
  RouterLinkedByOtherUser = 'ROUTER_LINKED_BY_OTHER_USER',
  RouterlinkNoRequestExists = 'ROUTERLINK_NO_REQUEST_EXISTS',
  RouterlinkInternalVpnError = 'ROUTERLINK_INTERNAL_VPN_ERROR',
  UnknownDevice = 'UNKNOWN_DEVICE',
  Error = 'ERROR'
}
